import AsyncSelect from 'react-select/async';
import { useContext, useEffect, useRef } from 'react';
import { AppContext } from '../context';

const AsyncContactController = (props) => {
  const { theme } = useContext(AppContext);

  // Per-instance debounce timer (a module-level timer would cross-cancel
  // between instances if this component ever gains a second consumer), with
  // unmount cleanup so a pending filter can't fire after the select is gone.
  const debounceRef = useRef(0);
  useEffect(() => () => window.clearTimeout(debounceRef.current), []);

  // AsyncSelect delegates ALL filtering to this function — it displays exactly
  // what we resolve, applying no client-side filter of its own. Resolving the
  // full list regardless of `value` (the pre-kan-81 behavior) therefore made
  // typing a no-op. The full company contact list is already in memory
  // (contactData, fetched once), so filter it here; no server round-trip.
  const promiseOptions = (value?: any): any =>
    new Promise((resolve) => {
      if (!value) {
        resolve(props?.contactData);
      } else {
        window.clearTimeout(debounceRef.current);
        debounceRef.current = window.setTimeout(() => {
          const needle = String(value).toLowerCase();
          resolve(
            (props?.contactData ?? []).filter((option: any) =>
              String(option?.label ?? '').toLowerCase().includes(needle)
            )
          );
        }, 300);
      }
    });

  const customStyles = {
    control: (styles, provided) => ({
      ...styles,
      width: `${props.width} !important`,
      background: theme === 'light' ? provided.background : '#282828',
      borderColor: theme === 'light' ? '#ced4da' : '#282828',
      color: theme === 'light' ? provided.background : '#d9d9d9',
      fontSize: 12,
      '&:hover': {
        borderColor: theme === 'light' ? '#ced4da' : '#282828',
        color: theme === 'light' ? provided.background : '#d9d9d9',
      },
    }),
    menu: (provided) => ({
      ...provided,
      background: theme === 'light' ? provided.background : '#282828',
      zIndex: props?.zIndex || 999999,
      color: theme === 'light' ? provided.background : '#d9d9d9',
    }),
    option: (provided) => ({
      ...provided,
      fontSize: 12,
      background: theme === 'light' ? provided.background : '#363636',
      '&:hover': {
        background: theme === 'light' ? provided.background : '#474444',
        color: theme === 'light' ? provided.background : '#d9d9d9',
      },
    }),
    container: (provided, state) => ({
      ...provided,
      fontSize: 12,
    }),
  };

  return (
    <>
      {props?.contactData?.length > 0 && !props.loading && (
        <AsyncSelect
          // cacheOptions
          isDisabled={props?.isDisabled || false}
          value={props?.value?.value ? props?.value : null}
          isSearchable
          // isClearable
          ref={props.ref}
          styles={{ ...customStyles }}
          defaultOptions
          onChange={(selected: any) => {
            if (props.onSelected) {
              if (selected) {
                props.onSelected(selected);
              } else {
                props.onSelected({});
              }
            }
            if (selected) {
              // setSelectValue(selected);
              props.onChange(selected);
            } else {
              props.onChange('');
            }
          }}
          loadOptions={promiseOptions}
          placeholder={props?.placeholder}
        />
      )}
    </>
  );
};

export default AsyncContactController;
